module.exports = __webpack_public_path__ + "img/twitter.43f8c9eb.svg";